<template>
  <div class="container">
    <span class="title is-3">{{ empresa.nombrec }}</span>
    <small class="title is-5"
      >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
    >
    <small class="subtitle is-7">{{ empresa.nombre }}</small>
    <hr />
    <div class="field is-grouped">
      <p class="control has-icons-left has-icons-right">
        <input
          class="input is-normal is-focused"
          type="text"
          v-model="search"
          placeholder="Buscar Productos"
        />
        <span class="icon is-medium is-left">
          <i class="material-icons">search</i>
        </span>
      </p>
      <div class="control">
        <div class="tags has-addons">
          <span class="tag is-medium has-background-grey-lighter"
            >Total Productos</span
          >
          <span class="tag is-info is-medium fontMono">{{
            pagination.count | number()
          }}</span>
        </div>
      </div>
      <p class="control" @click="fshowList">
        <button class="button">
          <span>Lista</span>
        </button>
      </p>
      <p class="control">
        <button class="button" @click="fshowForm">
          <span class="icon is-small">
            <span class="material-icons">add_circle_outline</span>
          </span>
          <span>Crear</span>
        </button>
      </p>
      <p class="control">
        <button class="button" @click="camposearch">
          <span class="icon is-small">
            <span class="material-icons">add_circle_outline</span>
          </span>
          <span>Campo search</span>
        </button>
      </p>
      <div class="control">
        <div class="select">
          <select v-model="lote" @change="updateEmpresa">
            <option :value="true">Con Lote</option>
            <option :value="false">Sin Lote</option>
          </select>
        </div>
      </div>
      <div class="control">
        <div class="select">
          <select v-model="structure" @change="updateEmpresa1">
            <option value="">No</option>
            <option value="J">Subestructura</option>
          </select>
        </div>
      </div>
      <p class="control">
        <button class="button" @click="recalcular">
          <span class="icon is-small">
            <span class="material-icons">loop</span>
          </span>
          <span>Recalcular</span>
        </button>
      </p>
    </div>
    <div>
      <div v-if="showList">
        <h1 class="title">Productos</h1>
        <table class="table is-hoverable is-fullwidth is-narrow">
          <thead>
            <tr>
              <th>#</th>
              <th>Código</th>
              <th v-if="empresa.structure === 'J'">Referencia</th>
              <th>Descripción</th>
              <th>Marca</th>
              <th>Linea</th>
              <th>Grupo</th>
              <th>Und</th>
              <th>Precio</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in products" :key="index">
              <td>{{ index + pagination.inicial * 20 + 1 }}</td>
              <td class="fontMono">
                <small
                  ><strong>{{ item.codigo }}</strong></small
                >
              </td>
              <td v-if="empresa.structure === 'J'" class="fontMono">
                <small>{{ item.structure }}</small>
              </td>
              <td>
                <small>{{ item.descripcion }}</small>
              </td>
              <td>
                <small>{{ item.marca }}</small>
              </td>
              <td>
                <small
                  >{{ item.linea.codigo }} {{ item.linea.descripcion }}</small
                >
              </td>
              <td>
                <small
                  >{{ item.grupo.codigo }} {{ item.grupo.descripcion }}</small
                >
              </td>
              <td>
                <small
                  >{{ item.unidad.codigo }}
                  <span style="font-size: 11px">{{
                    item.unidad.descripcion
                  }}</span></small
                >
              </td>
              <td class="has-text-right">
                <span class="fontMono">{{ item.precios[0] | number() }}</span>
              </td>
              <td>
                <span
                  class="icon has-text-info hand"
                  @click="selectProduct(item)"
                >
                  <i class="material-icons">edit</i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <nav class="pagination" role="navigation" aria-label="pagination">
          <a class="pagination-previous" @click="previous">Anterior</a>
          <a class="pagination-previous">{{ pagination.inicial + 1 }}</a>
          <a class="pagination-next" @click="next">Siguiente</a>
          <ul class="pagination-list">
            <li>
              <a
                class="pagination-link"
                :class="pagination.inicial === 0 ? 'is-current' : ''"
                aria-label="Page 1"
                aria-current="page"
                @click="ir(0)"
                >1</a
              >
            </li>
            <li v-show="pagination.total > 1">
              <a
                class="pagination-link"
                :class="pagination.inicial === 1 ? 'is-current' : ''"
                aria-label="Goto page 2"
                @click="ir(1)"
                >2</a
              >
            </li>
            <li v-show="pagination.total > 2">
              <a
                class="pagination-link"
                :class="pagination.inicial === 2 ? 'is-current' : ''"
                aria-label="Goto page 3"
                @click="ir(2)"
                >3</a
              >
            </li>
            <li>
              <span class="pagination-ellipsis">&hellip;</span>
            </li>
            <li v-show="pagination.total > 5">
              <a
                class="pagination-link"
                :class="
                  pagination.inicial === pagination.mitad - 1
                    ? 'is-current'
                    : ''
                "
                @click="ir(pagination.mitad - 1)"
                >{{ pagination.mitad }}</a
              >
            </li>
            <li>
              <span class="pagination-ellipsis">&hellip;</span>
            </li>
            <li v-show="pagination.total > 4">
              <a
                class="pagination-link"
                :class="
                  pagination.inicial === pagination.total - 1
                    ? 'is-current'
                    : ''
                "
                aria-label="Goto page 47"
                @click="ir(pagination.total - 1)"
                >{{ pagination.total }}</a
              >
            </li>
          </ul>
        </nav>
      </div>
      <div v-if="showForm">
        <h1 class="title is-4">{{ titleform }}</h1>
        <div class="columns is-multiline">
          <div class="column is-4">
            <div class="field">
              <label class="label">Código</label>
              <div class="control is-expanded">
                <input
                  v-model="product.codigo"
                  class="input"
                  type="text"
                  placeholder="Código"
                />
              </div>
            </div>
          </div>
          <div class="column is-4" v-if="empresa.structure === 'J'">
            <div class="field">
              <label class="label">Referencia</label>
              <div class="control is-expanded">
                <input
                  v-model="product.structure"
                  class="input"
                  type="text"
                  placeholder="Referencia"
                />
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Descripción</label>
              <div class="control is-expanded">
                <input
                  v-model="product.descripcion"
                  class="input"
                  type="text"
                  placeholder="Descripción"
                />
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Marca (Opcional)</label>
              <div class="control is-expanded">
                <input
                  v-model="product.marca"
                  class="input"
                  type="text"
                  placeholder="Marca"
                />
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label">Linea Contable</label>
              <div class="control is-expanded">
                <div class="select is-fullwidth">
                  <select v-model="product.linea">
                    <option
                      v-for="(line, index) in lineas"
                      :value="line._id"
                      :key="index"
                    >
                      {{ line.codigo }} {{ line.descripcion }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label">Grupos de Inventarios</label>
              <div class="control is-expanded">
                <div class="select is-fullwidth">
                  <select v-model="product.grupo">
                    <option
                      v-for="(grupo, index) in grupos"
                      :value="grupo._id"
                      :key="index"
                    >
                      {{ grupo.codigo }} {{ grupo.descripcion }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label">Unidad de Medida</label>
              <div class="control is-expanded">
                <div class="select is-fullwidth">
                  <select v-model="product.unidad">
                    <option
                      v-for="(und, index) in unidad"
                      :value="und._id"
                      :key="index"
                    >
                      {{ und.codigo }} {{ und.descripcion }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label">Precio de Venta</label>
              <div class="control is-expanded">
                <input
                  v-model="product.precio"
                  class="input"
                  type="number"
                  placeholder="Precio"
                />
              </div>
            </div>
          </div>
          <div
            class="column is-3"
            v-for="(lpr, index) in restoLprecios"
            :key="index"
          >
            <div class="field">
              <label class="label">Precio de Venta {{ lpr }}</label>
              <div class="control is-expanded">
                <input
                  v-model="product.precios[lpr]"
                  class="input"
                  type="number"
                  placeholder="Precio"
                />
              </div>
            </div>
          </div>
          <div class="column is-3" v-show="product._id">
            <div class="field">
              <label class="label">Activo</label>
              <div class="control is-expanded">
                <div class="select is-fullwidth">
                  <select v-model="product.active">
                    <option :value="true">Si</option>
                    <option :value="false">No</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-12">
            <label class="label">Imagen del producto</label>
          </div>
          <div class="column is-6">
            <div class="field">
              <div class="file is-primary">
                <label class="file-label">
                  <input
                    class="file-input"
                    type="file"
                    accept=".png, .jpg, jpeg"
                    @change="onFileChange"
                    name="resume"
                  />
                  <span class="file-cta">
                    <span class="file-icon">
                      <i class="material-icons">add_photo_alternate</i>
                    </span>
                    <span class="file-label">Seleccionar Imagen</span>
                  </span>
                </label>
              </div>
            </div>
            <progress
              v-show="avaceupload > 0"
              class="progress is-info is-small"
              :value="avaceupload"
              max="100"
            ></progress>
          </div>
          <div class="column is-6" v-if="product.urlimage">
            <figure class="image is-128x128 hand" @click="ampliar">
              <img v-show="product.urlimage" :src="urllogo" />
            </figure>
          </div>
          <div
            class="column is-12"
            v-if="empresa._id === '5f6cdde58b6256000fed8d98'"
          >
            <div class="field">
              <label class="label">Título del producto en la página</label>
              <div class="control">
                <input
                  v-model="product.titlepage"
                  class="input"
                  type="text"
                  placeholder="Título"
                />
              </div>
            </div>
          </div>
          <div
            class="column is-12"
            v-if="empresa._id === '5f6cdde58b6256000fed8d98'"
          >
            <div class="field">
              <label class="label">Message</label>
              <div class="control">
                <textarea
                  v-model="product.descriptionpage"
                  class="textarea"
                  placeholder="Textarea"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div v-if="product.tDatosproduct">
          <div v-for="(idbodega, index) in product.bodegas" :key="index">
            <br />
            <strong class="has-text-link"
              >Bodega {{ nombreBodega(idbodega) }}</strong
            >
            <span class="tag is-link fontMono">{{
              product.datosProducto[idbodega].existencia.unidades | number(2)
            }}</span>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">Existencia</label>
                  <div class="control is-expanded">
                    <input
                      v-model="
                        product.datosProducto[idbodega].existencia.unidades
                      "
                      class="input"
                      type="text"
                      placeholder="Descripción"
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">Costo</label>
                  <div class="control is-expanded">
                    <input
                      v-model="product.datosProducto[idbodega].existencia.total"
                      class="input"
                      type="text"
                      placeholder="Descripción"
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">Ultima Compra</label>
                  <div class="control is-expanded">
                    <input
                      v-model="
                        product.datosProducto[idbodega].ultimoCalculo.unidades
                      "
                      class="input"
                      type="text"
                      placeholder="Descripción"
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">Ultimo Costo</label>
                  <div class="control is-expanded">
                    <input
                      v-model="
                        product.datosProducto[idbodega].ultimoCalculo.total
                      "
                      class="input"
                      type="text"
                      placeholder="Descripción"
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">Costo Unitario</label>
                  <div class="control is-expanded">
                    <input
                      v-model="
                        product.datosProducto[idbodega].ultimoCalculo.costo
                      "
                      class="input"
                      type="text"
                      placeholder="Descripción"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="product.tLote && product.lote[idbodega]">
              <div
                class="columns"
                v-for="(lote, index1) in product.lote[idbodega].list"
                :key="index1"
              >
                <div class="column">
                  <div class="field">
                    <label class="label">Código {{ lote }}</label>
                    <div class="control is-expanded">
                      <input
                        class="input"
                        type="text"
                        :placeholder="lote"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">Nombre</label>
                    <div class="control is-expanded">
                      <input
                        v-model="product.lote[idbodega][lote].nombre"
                        class="input"
                        type="text"
                        placeholder="Nombre"
                      />
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">Existencia</label>
                    <div class="control is-expanded">
                      <input
                        v-model="product.lote[idbodega][lote].existencia"
                        class="input"
                        type="text"
                        placeholder="Nombre"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="buttons">
          <button class="button is-info" @click="saveProduct">
            <span class="material-icons">save</span>Guardar
          </button>
          <button class="button" @click="fshowList()">Cancelar</button>
          <button
            v-if="empresa._id === '5f6cdde58b6256000fed8d98' && showatention"
            @click="savepage"
            class="button is-primary"
          >
            Guardar en la Página
          </button>
          <!-- <button
            v-if="empresa._id === '5f6cdde58b6256000fed8d98' && !showatention"
            @click="editpage"
            class="button is-primary"
          >
            Editar en la Página
          </button> -->
          <button
            v-if="empresa._id === '5f6cdde58b6256000fed8d98' && !showatention"
            @click="deletepage"
            class="button is-danger"
          >
            Eliminar de la página
          </button>
        </div>
        <div class="notification is-warning" v-show="showatention">
          <h1 class="title is-5">Atención</h1>
          <h2 class="subtitle">Este producto no se encuentra en la página</h2>
        </div>
      </div>
    </div>
    <div class="modal" v-bind:class="{ 'is-active': showimage }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <p class="image">
          <img :src="urllogo" />
        </p>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="showimage = false"
      ></button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
export default {
  data() {
    return {
      showatention: false,
      avaceupload: 0,
      showimage: false,
      filename: "Seleccionar archivo",
      structure: "",
      lote: false,
      titleform: "Crear Producto",
      products: [],
      bodegas: [],
      restoLprecios: [],
      pagination: {
        count: 0,
        inicial: 0,
        total: 0,
        mitad: 0,
      },
      product: {
        codigo: "",
        descripcion: "",
        marca: "",
        linea: "",
        grupo: "",
        unidad: "",
        precio: "",
        active: "",
        tDatosproduct: false,
        tLote: false,
        bodegas: [],
        precios: [],
        urlimage: "",
        titlepage: "",
        descriptionpage: "",
      },
      search: "",
      showList: true,
      showForm: false,
      lineas: [],
      grupos: [],
      error: null,
    };
  },
  computed: {
    ...mapState(["empresa"]),
    urllogo() {
      if (this.product.urlimage) {
        return `${this.product.urlimage}`;
      } else {
        return "";
      }
    },
  },
  methods: {
    ampliar() {
      this.showimage = true;
    },
    async deletepage() {
      try {
        await apiServices.post(`/deletethepage`, {
          product: this.product,
        });
        this.findInfoproductToWebPage();
      } catch (err) {
        console.log(err);
      }
    },
    async editpage() {
      try {
        await apiServices.post(`/editthepage`, {
          product: this.product,
        });
        this.findInfoproductToWebPage();
      } catch (err) {
        console.log(err);
      }
    },
    async savepage() {
      try {
        await apiServices.post(`/savethepage`, {
          product: this.product,
        });
        this.findInfoproductToWebPage();
      } catch (err) {
        console.log(err);
      }
    },
    async submitFile() {
      try {
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("name", this.filename);
        formData.append("idproduct", this.product._id);
        const result = await apiServices.post(
          `/uploadimageproducttobase64`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.product.image64 = result.data.image64;
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Existen errores. No se pudo subir la imagen",
          type: "is-danger",
          duration: 4000,
        });
        this.error = err.response.data;
        console.log(this.error);
      }
    },
    onFileChange(e) {
      const _this = this;
      let task;
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        task = _this.$fire.logos(file);
        _this.avaceupload = 10;
        task.on(
          "state_changed",
          (snapshot) => {
            const porcentaje =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (porcentaje > 10) {
              _this.avaceupload = porcentaje;
            }
          },
          (err) => {
            console.log("error subiendo el archivo", err);
          },
          async () => {
            try {
              const url = await task.snapshot.ref.getDownloadURL();
              _this.avaceupload = 0;
              const result = await apiServices.post(`/uploadimageproduct`, {
                url,
                idproduct: _this.product._id,
              });
              this.product.urlimage = result.data.urlimage;
              console.log(result);
            } catch (err) {
              console.log("ocurrio un error", err);
            }
          }
        );
      }
    },
    nombreBodega(idbodega) {
      let nombre;
      const _this = this;
      for (let index = 0; index < this.bodegas.length; index++) {
        if (this.bodegas[index]._id === idbodega) {
          nombre = `${_this.bodegas[index].codigo} - ${_this.bodegas[index].descripcion}`;
          break;
        }
      }
      return nombre;
    },
    async updateEmpresa() {
      const query = {
        lote: this.lote,
      };
      const result = await apiServices.post(`/updateBatch`, query);
      if (result.data) {
        this.$store.commit("refreshEmpresa", result.data);
      }
    },
    async updateEmpresa1() {
      const query = {
        structure: this.structure,
      };
      const result = await apiServices.post(`/updateStructure`, query);
      if (result.data) {
        this.$store.commit("refreshEmpresa", result.data);
      }
    },
    async getBodegas() {
      try {
        this.cellars = [];
        const result = await apiServices.get(`/bodegas`);
        this.bodegas = result.data;
      } catch (err) {
        console.log(err);
      }
    },
    selectProduct(product) {
      const _this = this;
      _this.restoLprecios = [];
      function lprecios() {
        let returned = [];
        if (
          _this.empresa.modulos &&
          _this.empresa.modulos.pventa &&
          _this.empresa.modulos.pventa.listas
        ) {
          returned = Object.keys(_this.empresa.modulos.pventa.listas);
        }
        return returned;
      }
      const listasprecios = lprecios();
      this.product = {
        _id: product._id,
        codigo: product.codigo,
        descripcion: product.descripcion,
        marca: product.marca,
        linea: product.linea._id,
        grupo: product.grupo._id,
        unidad: product.unidad._id,
        precio: product.precios[0],
        active: product.active,
        precios: product.precios,
        image64: product.image64,
        urlimage: product.urlimage,
        titlepage: "",
        descriptionpage: "",
        bodegas: [],
      };
      if (_this.empresa.structure === "J") {
        _this.product.structure = product.structure;
      }

      if (product.datosProducto) {
        this.product.tDatosproduct = true;
        const bodegas = Object.keys(product.datosProducto);
        this.product.bodegas = bodegas;
        this.product.datosProducto = product.datosProducto;
        this.calculaProducto(product._id);
      } else {
        this.product.tDatosproduct = false;
      }

      if (product.lote) {
        this.product.tLote = true;
        this.product.lote = product.lote;
      } else {
        this.product.tLote = false;
      }

      listasprecios.forEach(function (k, v) {
        if (v !== 0) {
          _this.product.precios[k] = product.precios[k];
          _this.restoLprecios.push(k);
        }
      });

      if (this.empresa._id === "5f6cdde58b6256000fed8d98") {
        this.findInfoproductToWebPage();
      }
      this.fshowForm();
    },
    async findInfoproductToWebPage() {
      try {
        if (this.product.structure) {
          const result = await apiServices.get(
            `/findproductinwebpage/${this.product.structure}`
          );
          if (result.data.result) {
            this.showatention = false;
          } else {
            this.showatention = true;
          }
          this.product.titlepage = result.data.product.name;
          console.log(result);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async recalcular() {
      try {
        await apiServices.get(`/recalcularproducto`);
        this.find();
      } catch (err) {
        console.log(err);
      }
    },
    async calculaProducto(idproducto) {
      try {
        const _this = this;
        let result;
        result = await apiServices.get(`/calculaproducto/${idproducto}`);
        if (result.data) {
          const bodegas = { list: [] };
          for (let index in result.data) {
            const res = result.data[index];
            if (bodegas.list.indexOf(res._id.bodega) === -1) {
              bodegas.list.push(res._id.bodega);
              bodegas[res._id.bodega] = {
                existencia: 0,
                lotes: {
                  list: [],
                },
              };
            }
            if (
              bodegas[res._id.bodega].lotes.list.indexOf(
                res._id.batchcodigo ? res._id.batchcodigo : "*"
              ) === -1
            ) {
              bodegas[res._id.bodega].lotes.list.push(
                res._id.batchcodigo ? res._id.batchcodigo : "*"
              );
              bodegas[res._id.bodega].lotes[
                res._id.batchcodigo ? res._id.batchcodigo : "*"
              ] = {
                name: res._id.batchnombre ? res._id.batchnombre : "-",
                existencia: 0,
              };
            }
            bodegas[res._id.bodega].lotes[
              res._id.batchcodigo ? res._id.batchcodigo : "*"
            ].existencia += res.valor;
            bodegas[res._id.bodega].existencia += res.valor;
          }
          for (let index in bodegas.list) {
            const idbodega = bodegas.list[index];
            if (
              _this.product.datosProducto &&
              _this.product.datosProducto[idbodega]
            ) {
              _this.product.datosProducto[idbodega].existencia.unidades =
                bodegas[idbodega].existencia;
            }
            if (this.product.tLote) {
              _this.product.lote[idbodega] = { list: [] };
              for (let index2 in bodegas[idbodega].lotes.list) {
                const codigolote = bodegas[idbodega].lotes.list[index2];
                if (bodegas[idbodega].lotes[codigolote].existencia !== 0) {
                  _this.product.lote[idbodega].list.push(codigolote);
                  _this.product.lote[idbodega][codigolote] = {
                    nombre: bodegas[idbodega].lotes[codigolote].name,
                    existencia: bodegas[idbodega].lotes[codigolote].existencia,
                  };
                }
              }
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getLineas() {
      try {
        let result;
        result = await apiServices.get(`/lineas`);
        this.lineas = result.data;
      } catch (err) {
        console.log(err);
      }
    },
    async getGrupos() {
      try {
        let result;
        result = await apiServices.get(`/listgroup`);
        this.grupos = functions.order(result.data, "codigo");
      } catch (err) {
        console.log(err);
      }
    },
    async getUnidad() {
      try {
        let result;
        result = await apiServices.get(`/listunits`);
        this.unidad = functions.order(result.data, "codigo");
      } catch (err) {
        console.log(err);
      }
    },
    fshowForm() {
      if (this.product._id) {
        this.titleform = "Editar Producto";
      } else {
        this.titleform = "Crear Producto";
      }
      this.showForm = true;
      this.showList = false;
    },
    fshowList() {
      this.showList = true;
      this.showForm = false;
      this.product = {
        codigo: "",
        descripcion: "",
        marca: "",
        linea: "",
        grupo: "",
        unidad: "",
        precio: "",
        precios: [],
      };
      this.showatention = false;
      this.error = null;
    },
    async camposearch() {
      try {
        await apiServices.get("/addsearchproduct");
      } catch (err) {
        console.log(err);
      }
    },
    previous() {
      if (this.pagination.inicial > 0) {
        this.pagination.inicial--;
        this.find();
      }
    },
    next() {
      if (this.pagination.inicial + 1 < this.pagination.total) {
        this.pagination.inicial++;
        this.find();
      }
    },
    ir(n) {
      this.pagination.inicial = n;
      this.find();
    },
    async find() {
      try {
        const _this = this;
        const f = {
          search: _this.search,
          inicial: _this.pagination.inicial * 20,
        };
        let result;
        result = await apiServices.post(`/searchproducto`, f);
        _this.products = result.data.data;
        _this.pagination.count = result.data.count;
        _this.pagination.total = Math.ceil(_this.pagination.count / 20);
        _this.pagination.mitad = Math.round(
          (_this.pagination.total - 3) / 2 + 3
        );
        if (_this.products.length === 0) {
          _this.pagination.inicial = 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async saveProduct() {
      try {
        if (!this.product.codigo) {
          this.error = "El producto debe tener un código";
          return false;
        }
        if (!this.product.descripcion) {
          this.error = "El producto debe tener una descripción";
          return false;
        }
        if (!this.product.linea) {
          this.error = "Debe seleccionar una linea";
          return false;
        }
        if (!this.product.grupo) {
          this.error = "Debe selecionar un grupo";
          return false;
        }
        if (!this.product.unidad) {
          this.error = "Debe seleccionar una unidad de medida";
          return false;
        }
        if (!this.product.precio) {
          this.product.precios = {
            0: 0,
          };
        } else {
          if (this.product.precios && this.product.precios[0]) {
            this.product.precios[0] = parseFloat(this.product.precio);
          } else {
            this.product.precios = {
              0: parseFloat(this.product.precio),
            };
          }
        }
        let result;
        if (this.product._id) {
          result = await apiServices.put(`/editproduct`, this.product);
        } else {
          result = await apiServices.post(`/createproduct`, this.product);
        }
        if (result.data.existProduct) {
          this.error = "El producto ya existe";
        } else {
          if (this.product._id) {
            this.$store.dispatch("notify", {
              message: "Perfecto!. El producto fue editado.",
            });
          } else {
            this.$store.dispatch("notify", {
              message: "Perfecto!. El producto fue creado.",
            });
          }
          this.search = "";
          this.find();
          this.fshowList();
          this.product = {
            codigo: "",
            descripcion: "",
            marca: "",
            linea: "",
            grupo: "",
            unidad: "",
            precio: "",
            precios: [],
          };
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    search(nv, ov) {
      this.find();
    },
    error(nv, ov) {
      if (nv) {
        this.$store.dispatch("notify", {
          message: nv,
          type: "is-warning",
          position: "top-center",
        });
      }
    },
    empresa(nv, ov) {
      if (nv._id !== "no id") {
        this.lote = nv.lote;
        this.structure = nv.structure;
      }
    },
  },
  created() {
    this.find();
    this.getLineas();
    this.getGrupos();
    this.getUnidad();
    this.getBodegas();
    if (this.empresa._id !== "no id") {
      this.lote = this.empresa.lote;
      this.structure = this.empresa.structure;
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/configurations/products/Products.vue